function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { fetchTransactionNoteReview, updateTransactionNoteReviewState } from '@engine/actions/creators/transaction-note-review';
import Button from '@engine/components/presentational/base/button';
import Icon from '@engine/components/presentational/base/icon';
import Modal from '@engine/components/presentational/base/modal';
import React from 'react';
import Spinner from '@engine/components/presentational/base/spinner';
import { connect } from 'react-redux';

var TransactionNoteReview = /*#__PURE__*/function (_React$Component) {
  _inherits(TransactionNoteReview, _React$Component);

  var _super = _createSuper(TransactionNoteReview);

  function TransactionNoteReview(props) {
    var _this;

    _classCallCheck(this, TransactionNoteReview);

    _this = _super.call(this, props);
    _this.state = {
      isModalOpened: false
    };
    _this.locales = {
      areYouSure: I18n.t('shared.actions.are_you_sure'),
      cancel: I18n.t('shared.actions.cancel'),
      markNoteAsReviewed: I18n.t('javascript.helpers.application.mark_note_as_reviewed'),
      yes: I18n.t('shared.actions.yes')
    };
    return _this;
  }
  /**
   * Component life cycle
   */


  _createClass(TransactionNoteReview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.updateTransactionNoteReviewState({
        transaction_note: this.props.transactionNote
      });
    }
    /**
     * Render component
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.transactionNoteState && this.transactionNoteState.reviewed_by) {
        return React.createElement("span", {
          className: "text-success",
          title: this.props.reviewedBy
        }, React.createElement(Icon, {
          icon: "ok"
        }));
      }

      if (this.hasErrors) {
        return React.createElement(Icon, {
          icon: "exclamation-sign"
        });
      }

      return React.createElement(React.Fragment, null, this.transactionNoteReview.isReviewing ? React.createElement(Spinner, {
        position: "center",
        color: "refined-blue",
        size: "tiny"
      }) : React.createElement(Button, {
        onClick: function onClick() {
          return _this2.openModal();
        },
        title: this.locales.markNoteAsReviewed,
        type: "link",
        icon: "envelope"
      }), this.state.isModalOpened && React.createElement(Modal, {
        isOpened: this.state.isModalOpened,
        title: this.locales.areYouSure,
        closeModal: function closeModal() {
          return _this2.closeModal();
        },
        footer: React.createElement(React.Fragment, null, React.createElement(Button, {
          onClick: function onClick() {
            return _this2.closeModal();
          }
        }, this.locales.cancel), React.createElement(Button, {
          onClick: function onClick() {
            return _this2.review();
          },
          type: "success",
          className: "confirm"
        }, this.locales.yes))
      }), this.isReviewedAndWithoutErrors && this.closeModal());
    }
    /**
     * Computed properties
     */

  }, {
    key: "transactionNoteID",
    get: function get() {
      return this.props.transactionNote.id;
    }
  }, {
    key: "transactionNoteReview",
    get: function get() {
      return this.props.transactionNoteReview;
    }
  }, {
    key: "transactionNoteState",
    get: function get() {
      return this.transactionNoteReview.transactionNote;
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return this.transactionNoteReview.hasErrors;
    }
  }, {
    key: "isReviewedAndWithoutErrors",
    get: function get() {
      return this.transactionNoteReview.isReviewed && !this.hasErrors;
    }
    /**
     * Methods
     */

  }, {
    key: "review",
    value: function review() {
      this.props.fetchTransactionNoteReview(this.props.url, {
        id: this.transactionNoteID
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState({
        isModalOpened: true
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        isModalOpened: false
      });
    }
  }]);

  return TransactionNoteReview;
}(React.Component);

export default connect(function (state, ownProps) {
  return {
    transactionNoteReview: state["transactionNoteReview-".concat(ownProps.transactionNote.id)]
  };
}, {
  fetchTransactionNoteReview: fetchTransactionNoteReview,
  updateTransactionNoteReviewState: updateTransactionNoteReviewState
})(TransactionNoteReview);